import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import WebexGuide from './views/WebexGuide.vue'
import PrivacyPolicy from './views/PrivacyPolicy.vue'
import ProviderList from './views/ProviderList.vue'
import Affilliates from './views/Affilliates'
import ImportantDeadlines from './views/ImportantDeadlines.vue'
import Accommodation from './views/Accommodation.vue'
import AdditionalServices from './views/AdditionalServices.vue'
import Venue from './views/Venue.vue'
import Markets from './views/Markets.vue'
import Gallery from './views/Gallery.vue'
import Companies from './views/Companies.vue'
import AuthedCompanies from './views/AuthedCompanies.vue'
import PageNotFound from './views/PageNotFound.vue'
import UsefulInformation from './views/UsefulInformation.vue'
import Preferences from './views/auth/Preferences.vue'
import SchedulePreview from './views/auth/SchedulePreview.vue'
import MySurvey from './views/auth/MySurvey.vue'
import EmailPassword from './views/auth/EmailPassword.vue'
import ResetPassword from './views/auth/ResetPassword.vue'
import Identify from './views/auth/registration/Identify.vue'
import Cancellation from './views/auth/registration/Cancellation.vue'
import ConfirmCancellation from './views/auth/registration/ConfirmCancellation.vue';
import Register from './views/auth/registration/Register.vue'
import Thank from './views/auth/registration/Thank.vue'
import ThankAfterRegistration from './views/auth/registration/ThankAfterRegistration.vue'
import login from './views/auth/login.vue'
import Test from './views/auth/Test.vue'
import store from './store'

Vue.use(Router)

let router =  new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
        path: '/',
        name: 'home',
        component: Home
    },
    // {
    //     path: '/accommodation',
    //     name: 'Accommodation',
    //     component: Accommodation
    // },
    // {
    //     path: '/additional-services',
    //     name: 'AdditionalServices',
    //     component: AdditionalServices
    // },
    {
        path: '/companies',
        name: 'Companies',
        component: Companies
    },
    {
        path: '/webex-guide',
        name: 'WebexGuide',
        component: WebexGuide
    },
    {
        path: '/privacy-policy',
        name: 'PrivacyPolicy',
        component : PrivacyPolicy
    },
    {
        path: '/provider-list',
        name: 'ProviderList',
        component: ProviderList
    },
    {
        path: '/affilliates',
        name: 'Affilliates',
        component: Affilliates
    },
    {
        path: '/important-deadlines',
        name: 'ImportantDeadlines',
        component: ImportantDeadlines
    },
    // {
    //     path: '/markets',
    //     name: 'Markets',
    //     component: Markets
    // },
    // {
    //     path: '/useful-information',
    //     name: 'UsefulInformation',
    //     component: UsefulInformation
    // },
    // {
    //     path: '/gallery',
    //     name: 'Gallery',
    //     component: Gallery
    // },
    // {
    //     path: '/venue',
    //     name: 'Venue',
    //     component: Venue
    // },
    {
        path: '/auth/companies',
        name: 'AuthedCompanies',
        component: AuthedCompanies,
        meta: {
            requiresAuth : true
        }
    },
    {
        path: '/auth/registration/identify',
        name: 'Identify',
        component: Identify
    },
    {
        path: '/auth/registration/signup',
        name: 'register',
        component: Register
    },
    {
        path: '/auth/registration/thank',
        name: 'Thank',
        component: Thank
    },
    {
        path: '/auth/registration/after-update-prefs',
        name: 'ThankAfterRegistration',
        component: ThankAfterRegistration
    },
    {
        path: '/auth/login',
        name: 'login',
        component: login,
        meta: {
            guestOnly: true
        }
    },
    {
        path: '/auth/password/email',
        name: 'EmailPassword',
        component: EmailPassword,
    },
    {
        path: '/auth/password/reset',
        name: 'ResetPassword',
        component: ResetPassword,
    },
    {
        path: '/auth/registration/mail/action/cancellation',
        name: 'ConfirmCancellation',
        component: ConfirmCancellation,
        meta:{
            requiresAuth : true
        }
    },
   {
        path: '/auth/registration/mail/action/cancellation-confirmed',
        name: 'Cancellation',
        component: Cancellation,
        meta:{
            requiresAuth : true
        }
    },
    {
        path: '/auth/preferences',
        name: 'preferences',
        component: Preferences,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/auth/schedule-preview',
        name: 'SchedulePreview',
        component: SchedulePreview,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/auth/my-survey',
        name: 'MySurvey',
        component: MySurvey,
        meta: {
            requiresAuth: true
        }
    },
    {
      path: '*',
      name: '404Page',
      component: PageNotFound,
    }





  ]
});
const DEFAULT_AUTH = '/auth/registration/signup'

router.beforeEach((to, from, next) => {

  if(to.matched.some(record => record.meta.guestOnly)) {
        if (store.getters.isLoggedIn) {
            window.location.replace(DEFAULT_AUTH)
            return ;
        }
  }
  if(to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.isLoggedIn) {
      next()
      return
    }

    let path = to.path ;
    if( to.query.cancelation_token )
    {
        path = `${path}?cancelation_token=${to.query.cancelation_token}`;
    }
    // localStorage.setItem('redirect', path);
    // this.$router.push({ name: 'login', query: { redirect: path } });
    next({ name: 'login', query: { redirect: path } })
    return;
  } else {
    next()
  }
});

export default router;
